"use client";

import Auth from "@/_app/landing/auth";
import CompareCta from "@/_app/landing/compare-cta";
import ContentMonitor from "@/_app/landing/content-monitor";
import Difference from "@/_app/landing/difference";
import Faq from "@/_app/landing/faq";
import Feature from "@/_app/landing/feature";
import Hero from "@/_app/landing/hero";
import Integration from "@/_app/landing/integration";
import Pricing from "@/_app/landing/pricing";
import VideoSection from "@/_app/landing/video";

export default function LandingPage() {
  return (
    <div className="flex flex-col md:gap-16 gap-8 w-full">
      <Hero />

      <VideoSection />

      <Difference />

      <Feature />

      <ContentMonitor />

      <Integration />

      <CompareCta />

      <Pricing />

      <Auth />

      <div className="mt-16">
        <Faq />
      </div>

      <div className="absolute inset-0 min-h-screen overflow-hidden z-10 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full bg-primary/30 blur-[120px] dark:opacity-50 opacity-15" />
      </div>
    </div>
  );
}
